import React from 'react';
import { ImpacterResponse } from '../../types/ImpacterTypes';
import { getFromEnterpriseBackend } from '../../utils/api';
import ImpacterListLayout, {
  ImpactersSectionImpacter,
  ImpactersSectionProps,
} from '../component-library/layout/ImpacterList/ImpacterListLayout';
import SectionBackground from '../component-library/SectionBackground';
import { TemplatingContext } from './contexts/TemplatingContext';
import { PageSectionComponent } from './pageSections';
import RichText from './RichText/RichText';
import { createTemplateReplacer } from './util/mergeTagsTemplates';
import pageToCompatibleProps from './util/pageToCompatibleProps';
import sectionToCompatibleProps from './util/sectionToCompatibleProps';

const ImpactersSection: PageSectionComponent<ImpactersSectionProps> = ({
  section,
  serverSideProps: { impacters = [], prioritizedImpacterIds },
}) => {
  const { id, title, description, backgroundColor, help } = sectionToCompatibleProps({ section });

  /** Change the content in the help text to include the number of impacters **/
  const scope = { impacters: impacters.length };
  const templateReplacer = createTemplateReplacer(scope);

  return (
    <SectionBackground id={id} backgroundColor={backgroundColor}>
      <TemplatingContext.Provider
        value={{
          ...scope,
          templateReplacer,
        }}
      >
        <ImpacterListLayout
          Title={({ color }) => <RichText document={title} textColor={color} />}
          description={<RichText document={description} />}
          help={<RichText skipWrapper document={help} />}
          impacters={impacters}
          prioritizedImpacterIds={prioritizedImpacterIds}
        />
      </TemplatingContext.Provider>
    </SectionBackground>
  );
};

ImpactersSection.getCustomServerSideProps = async ({ page, section }) => {
  const { campaignTag, prioritizedImpacterIds } = pageToCompatibleProps({
    page,
    settings: section.fields.settings,
  });
  const impacters = (
    await getFromEnterpriseBackend<{
      result: (ImpactersSectionImpacter &
        Pick<ImpacterResponse, 'actionShotWideUrl' | 'actionShotWide'>)[];
    }>('impacters', {
      anyTagNames: campaignTag ? [campaignTag] : undefined,
      fields: ['id', 'name', 'organisationName', 'tagline', 'location', 'actionShotWide'],
      skipSources: true,
    })
  ).result
    .filter((impacter) => impacter?.actionShotWideUrl)
    .map((impacter) => {
      // clean up unnecessary data to avoid bloating the props sent to the client
      delete impacter.actionShotWide;
      delete impacter.actionShotWideUrl;
      return impacter;
    });
  return { impacters, prioritizedImpacterIds };
};

export default ImpactersSection;
